import { render, staticRenderFns } from "./BasicPopover.vue?vue&type=template&id=51b20aa7"
import script from "./BasicPopover.vue?vue&type=script&lang=js"
export * from "./BasicPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports